module.exports = __webpack_public_path__ + "img/epk-photo-3.2d5a84f3.jpeg";